import * as React from "react";
const EnergySavingIcon = (props) => (
  <svg
    width={39}
    height={39}
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23 16.875V12.5M16 16.875V12.5M19.5 37C29.1652 37 37 29.1652 37 19.5C37 9.83475 29.1652 2 19.5 2C9.83475 2 2 9.83475 2 19.5C2 29.1652 9.83475 37 19.5 37Z"
      stroke="#1C8327"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 26.5C21.3565 26.5 23.137 25.7625 24.4497 24.4497C25.7625 23.137 26.5 21.3565 26.5 19.5V16.875H12.5V19.5C12.5 21.3565 13.2375 23.137 14.5503 24.4497C15.863 25.7625 17.6435 26.5 19.5 26.5Z"
      stroke="#1C8327"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 37V26.5"
      stroke="#1C8327"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EnergySavingIcon;
